import HygraphImage, { HygraphImageProps } from '@/components/hygraph-image';
import Row from '@/components/row';
import Section from '@/components/section';
import Typography from '@/components/typography';

import { RowLayout } from '@/enums/row-layout';

export type SparkLineWithIllustrationProps = {
  caption?: string;
  heading?: string;
  content?: string;
  image?: HygraphImageProps;
};

export const SparkLineWithIllustration = ({
  caption,
  heading,
  content,
  image,
}: SparkLineWithIllustrationProps) => {
  return (
    <Section>
      <Row layout={RowLayout.TWO_COLUMN_HALFS}>
        <div className='flex h-full lg:relative'>
          <div className='max-w absolute -left-[5px] top-0 w-[90%] lg:left-auto lg:w-[125%]'>
            <SparkLine />
          </div>
          <div className='relative z-10 mt-[40%] pb-4 lg:mt-[25%] lg:w-11/12'>
            <div className='min-h-[100px] w-[65%] lg:mb-0 lg:w-full'>
              {caption && (
                <Typography.Subtitle2
                  overline={false}
                  className='mb-3 lg:text-[20px]'
                >
                  {caption}
                </Typography.Subtitle2>
              )}
              {heading && <Typography.Heading1>{heading}</Typography.Heading1>}
            </div>
            {content && (
              <div className='mt-3 w-full md:w-[70%] lg:w-full'>
                <Typography.Body2>{content}</Typography.Body2>
              </div>
            )}
          </div>
        </div>
        <div className='flex h-full items-end justify-center'>
          {image && <HygraphImage {...image} />}
        </div>
      </Row>
    </Section>
  );
};
export default SparkLineWithIllustration;

const SparkLine = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='w-full'
    viewBox='0 0 777 437'
    fill='none'
  >
    <path
      d='M2.60704 119.855C2.60704 119.855 135.477 -29.7419 317.234 8.98855C560.904 60.912 606.978 383.249 612.734 433.817C612.83 434.662 614.234 434.542 614.359 433.701C620.196 394.216 655.38 194.242 774.849 147.148'
      className='stroke-primary stroke-[6px] sm:stroke-[4px]'
      strokeWidth='4'
      strokeLinecap='round'
    />
  </svg>
);
